const RUNTIME_API_CONFIG_PATH = '/kaiho-biku/assets/json/runtime-api-config.json';
const STAGING_BADGE_ID = 'zeta-api-staging-badge';

let runtimeApiConfigPromise;
const loggedStagingEndpoints = new Set();

function createStagingBadge() {
  const badge = document.createElement('div');
  badge.id = STAGING_BADGE_ID;
  badge.textContent = 'ZETA API ステージング用を呼び出し中';
  badge.setAttribute('aria-live', 'polite');
  badge.style.position = 'fixed';
  badge.style.right = '12px';
  badge.style.bottom = '12px';
  badge.style.zIndex = '9999';
  badge.style.padding = '8px 10px';
  badge.style.borderRadius = '999px';
  badge.style.background = 'rgba(196, 30, 58, 0.9)';
  badge.style.color = '#fff';
  badge.style.fontSize = '12px';
  badge.style.lineHeight = '1.3';
  badge.style.fontWeight = '700';
  badge.style.letterSpacing = '0.01em';
  badge.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.25)';
  return badge;
}

function showStagingBadge() {
  const appendBadge = () => {
    if (!document.body) return;
    if (document.getElementById(STAGING_BADGE_ID)) return;
    document.body.appendChild(createStagingBadge());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', appendBadge, { once: true });
    return;
  }

  appendBadge();
}

function normalizeEndpoint(value) {
  if (typeof value !== 'string') return '';
  return value.trim().replace(/\/+$/, '');
}

function normalizeRuntimeApiConfig(json) {
  const source = json && typeof json === 'object' ? json : {};

  return {
    searchEndpoint: normalizeEndpoint(
      source.searchEndpoint || source.search_endpoint || source.articleEndpoint
    ),
    hashtagEndpoint: normalizeEndpoint(
      source.hashtagEndpoint || source.hashtag_endpoint || source.tagEndpoint
    )
  };
}

export async function loadRuntimeApiConfig() {
  if (runtimeApiConfigPromise) return runtimeApiConfigPromise;

  runtimeApiConfigPromise = fetch(RUNTIME_API_CONFIG_PATH, {
    cache: 'no-store'
  })
    .then((response) => {
      if (!response.ok) {
        return null;
      }
      return response.json();
    })
    .then((json) => normalizeRuntimeApiConfig(json))
    .catch(() => ({
      searchEndpoint: '',
      hashtagEndpoint: ''
    }));

  return runtimeApiConfigPromise;
}

export function isStagingZetaApiEndpoint(endpoint) {
  if (!endpoint) return false;

  try {
    const url = new URL(endpoint, location.origin);
    return url.hostname.startsWith('dev.');
  } catch (_) {
    return false;
  }
}

export function logStagingZetaApiUsage(endpoint) {
  const key = String(endpoint || '').trim();
  if (!key) return;
  if (!isStagingZetaApiEndpoint(key)) return;
  if (loggedStagingEndpoints.has(key)) return;

  loggedStagingEndpoints.add(key);
  showStagingBadge();
  console.info('ZETA API ステージング用を呼び出し中');
}
